import React, { useState, useEffect, useRef } from 'react';
import ApiHandler from "./../../../../services/api/ApiHandler";
import apiPayload from './../../../../services/api/ApiPayload';
import localStorageService from './../../../../helpers/store/StorageService';
import CloudLoader from './../../loader/Loader_02';

const Disconnect = ({ contentData, initError, initLoader }) => {
  const hasRun = useRef(false);  // Ref to track if effect has run
  let { data, loading, error, handlePostApi } = ApiHandler();
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState(null);
  const [loginCode, setLoginCode] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);  // Success flag for button

  useEffect(() => {
    if (hasRun.current) return;  // Skip if already run
    let isMounted = true;
    if (isMounted) {
      setIsLoading(true);
      setServerError(null);
      setIsSuccess(false);
      try {
        apiPayload.set('load.pageId', 'Page30006');
        apiPayload.set('load.redirectRoute', '/disconnect');
        apiPayload.set('load.data.userId', localStorageService.get('active', -1, 'int'));
        handlePostApi("/v1/disconnect", apiPayload.fetchPayload());
      } catch (err) {
        setServerError({ general: 'API error', error: error });
        console.warn(err);
      } finally {
        setIsLoading(false);
      }
    }

    hasRun.current = true;  // Flag as run

    // Cleanup to prevent updates after unmount
    return () => {
      isMounted = false;
    };
    // TODO : Clear the warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data && data.code === "200") {
      localStorageService.remove('report');
      localStorageService.remove('active');
      setLoginCode(data.result.api_request_data.d_auth_code ?? null);
      setIsSuccess(true);
    } else if (data && data.code !== "200") {
      setServerError({ general: data.result.api_request_data.error });
    }
  }, [data]);

  const handleConfirm = () => {
    window.location.href = '/getting-started';
  };

  const handleCopy = () => {
    if (loginCode !== null && isSuccess) {
      navigator.clipboard.writeText(loginCode).then(() => {
        console.log('Copied to clipboard!');
      }).catch((err) => {
        console.error('Failed to copy: ', err);
      });
    }
  };

  return (
    <div style={{ position: 'relative'}}>
      {initLoader && <CloudLoader />}
      {loading && <CloudLoader />}
      {isLoading && <CloudLoader />}
      {loginCode !== null && isSuccess && (
        <div className="alert-container success-indicator">
          <h1 className='disconnect-alert'><strong>You are disconnected</strong></h1>
          <h2><strong>Come back anytime - you are safe with us!</strong></h2>
          <hr style={{border:'none', height:'2px', background:'linear-gradient(to right, #e600c7 0%, #940180 25%, rgb(0, 0, 0) 100%)', boxShadow: 'rgba(0, 0, 0, 0.5) 0px 1px 3px inset', margin:'20px 0px', width:'100%'}} />
          <h3><strong>Your Access Code</strong></h3>
          <h1 className='login-code'><strong>{loginCode || 'Unknown'}</strong></h1>
          <button onClick={handleCopy} className="clipboard-button">Copy Code</button>
          <button className="getting-started" onClick={handleConfirm}><h3>Ok, I saved it</h3></button>
        </div>
      )}
      {serverError?.general && <span className="error">{serverError.general}</span>}
      {initError && <span className="error">{initError}</span>}
    </div>
  );
};

export default Disconnect;
